// @ts-check
import React from 'react';
import classes from './LoadingSlotsIndicator.module.scss';

const LoadingSlotsIndicator = () => (
  <div>
    <div className={classes.spinner} />
    <div className={classes.label}>Loading...</div>
  </div>
);

LoadingSlotsIndicator.displayName = 'LoadingSlotsIndicator';

export default LoadingSlotsIndicator;
